module.exports = __webpack_public_path__ + "static/img/time-line-gold-ar.09c2093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/time-line-gold-ar.png
// module id = 1234
// module chunks = 4